<div class="minFullHeight">
    <div class="pt-10 d-flex flex-col align-items-center" role="status">
        <mat-spinner aria-label="Signing you in" class="mx-auto" color="accent"></mat-spinner>
        <p>Signing you in…</p>
    </div>
</div>
